<template>
    <div>
        <v-container grid-list-xs>
            <v-row>
                <v-col>
                    <v-card>
                        <v-card-actions>
                            <BackButton />
                        </v-card-actions>
                        <v-card-text>
                            <v-subheader class="text-subtitle-1 font-weight-bold">PARTICIPATING CREDITORS</v-subheader>
                            In connection with the Platform, Company will request that one or more Participating
                            Creditors make a specific extension of credit directly or indirectly to you. The names and
                            addresses of the Participating Creditors with which we may share your information are as
                            follows:
                            <br />
                            <br />
                            <table id="creditor-table">
                                <thead>
                                    <tr>
                                        <th>Participating Creditor Name</th>
                                        <th>Participating Creditor Address</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            Your
                                            {{
                                                $t("app.terms.prequalilfication-participating-creditor-name-brand")
                                            }}
                                            Service Provider (supported by HFD) ({{
                                                $t("app.terms.prequalilfication-company-service-brand")
                                            }}
                                            and our subsidiaries are not dental providers or creditors)
                                        </td>
                                        <td>
                                            The address of your
                                            {{
                                                $t("app.terms.prequalilfication-participating-creditor-address-brand")
                                            }}
                                            dental service provider (generally the location at which you obtain dental
                                            services)
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Your
                                            {{
                                                $t("app.terms.prequalilfication-participating-creditor-name-brand")
                                            }}
                                            Service Provider (supported by AFF) ({{
                                                $t("app.terms.prequalilfication-company-service-brand")
                                            }}
                                            and our subsidiaries are not dental providers or creditors)
                                        </td>
                                        <td>
                                            The address of your
                                            {{
                                                $t("app.terms.prequalilfication-participating-creditor-address-brand")
                                            }}
                                            dental service provider (generally the location at which you obtain dental
                                            services)
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>FinWise Bank sub-serviced by American First Finance (AFF)</td>
                                        <td>Care of American First Finance, P.O. Box 565848, Dallas, TX 75356</td>
                                    </tr>
                                    <tr>
                                        <td>Hatch Bank (supported by HFD)</td>
                                        <td>1001 W San Marcos Blvd San Marcos, California 92078</td>
                                    </tr>
                                    <tr>
                                        <td>Lending Club</td>
                                        <td>595 Market Street, #200, San Francisco, CA 94105</td>
                                    </tr>
                                    <tr>
                                        <td>Proceed Finance</td>
                                        <td>425 Fallbrook Blvd, Lincoln, NE 68521</td>
                                    </tr>
                                    <tr>
                                        <td>Synchrony Bank (dba CareCredit)</td>
                                        <td>170 Election Road, Suite 125, Draper, UT 84020</td>
                                    </tr>
                                    <tr>
                                        <td>The Bank of Missouri</td>
                                        <td>916 N Kings Hwy, Perryville, MO 63775</td>
                                    </tr>
                                </tbody>
                            </table>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    export default {}
</script>

<style lang="scss" scoped>
    .v-card__text {
        color: #000000 !important;

        .theme--light.v-subheader {
            color: #000000;
        }
    }

    table {
        width: 100%;
        border-collapse: collapse;
    }
    table,
    th,
    td {
        border: 1px solid black;
    }
    th,
    td {
        padding: 10px;
        text-align: left;
    }
</style>
